import { render, staticRenderFns } from "./AddCorporate.vue?vue&type=template&id=e927edf8"
import script from "./AddCorporate.vue?vue&type=script&lang=js"
export * from "./AddCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports